export enum PillType {
  draft = 'draft',
  info = 'info',
  done = 'done',
  attention = 'attention',
  error = 'error'
}
